<!-- Webinars in a room -->
<div class="draw-page">

  <div class="fragment ooo-banner" *ngIf="numberOfOOO > 0 && showMessage">
    <span id="close" (click)="showMessage = false" style="font-size: 20px;">×</span>
    <h3 style="font-size: 24px;">Out of Office</h3>
    <br />
    <p class="textOOO" style="color: white !important; line-height: 1.5;">
      I’m out of the office for
      <b>
        <span style="font-weight: bold;">{{numberOfOOO}}</span>
        <span *ngIf="numberOfOOO > 1"> Days.</span>
        <span *ngIf="numberOfOOO === 1"> Day.</span>
      </b>
      <br />
      <b><i><span style="font-weight: bold;"> Message 👉 </span></i></b> hey all, will be out on the following dates -
      <span style="font-weight: bold;"><u>{{outOfficeDays}}</u></span>
      <br />
      <b><i> **Note 👉 </i></b> All Webinars with seat reservations will still run. No new Webinars will be posted during this time.
    </p>
  </div>

  <section class="draw-section">
    <p class="draw-kicker">This room</p>
    <h1 class="draw-heading">Grab a seat</h1>
    <p class="draw-sub">Price, remaining seats, and live listings — tap a card to jump in.</p>

    <div class="draw-empty" *ngIf="allWebinars && allWebinars.length === 0">
      No webinars with open seats in this room right now.
    </div>

    <div class="draw-grid" *ngIf="allWebinars?.length" [attr.data-count]="allWebinars.length">
      <article
        class="draw-tile"
        *ngFor="let webinar of allWebinars"
        [class.draw-tile--hot]="isLowSeats(webinar)"
        [class.draw-tile--sold]="isSoldOut(webinar)"
        [class.draw-tile--featured]="isFeatured(webinar)"
        role="link"
        tabindex="0"
        [attr.aria-label]="webinar.name"
        (click)="OpenWebinar(webinar.webinarId)"
        (keyup.enter)="OpenWebinar(webinar.webinarId)">
        <div class="draw-tile__media">
          <img
            class="draw-tile__image"
            [src]="webinar.imageUrl || 'assets/Images/demo1.png'"
            [alt]="webinar.name" />
          <div class="draw-tile__shine" aria-hidden="true"></div>
          <span class="draw-ribbon draw-ribbon--free" *ngIf="webinar.isFreeBee">Freebie</span>
          <span class="draw-ribbon draw-ribbon--new" *ngIf="webinar.webinarId === latestWebinarId && !webinar.isFreeBee">New</span>
          <span class="draw-tile__price" [class.draw-tile__price--free]="isFree(webinar)">{{ displayPrice(webinar) }}</span>
        </div>

        <div class="draw-tile__body">
          <h2 class="draw-tile__name">{{ webinar.name }}</h2>

          <div class="draw-stats" [class.draw-stats--admin]="isLoggedInUserHostOrAdmin">
            <div class="draw-stat">
              <span>Total seats</span>
              <strong>{{ webinar.numberOfSeats }}</strong>
            </div>
            <div class="draw-stat draw-stat--price">
              <span>Per seat</span>
              <strong>
                <span class="gold-dollar" *ngIf="!isFree(webinar)">$</span>{{ priceAmount(webinar) }}
              </strong>
            </div>
            <div class="draw-stat draw-stat--left" [class.draw-stat--hot]="isLowSeats(webinar)" [class.draw-stat--sold]="isSoldOut(webinar)">
              <span>{{ isSoldOut(webinar) ? 'Sold out' : 'Open now' }}</span>
              <strong>{{ webinar.seatsLeft }}</strong>
            </div>
            <div class="draw-stat" *ngIf="isLoggedInUserHostOrAdmin">
              <span>Projected</span>
              <strong>{{ formatPrice(webinar.grossProjectedSale) }}</strong>
            </div>
          </div>

          <div class="draw-meter" [attr.aria-label]="seatsLeftLabel(webinar)">
            <div
              class="draw-meter__fill"
              [class.draw-meter__fill--hot]="isLowSeats(webinar)"
              [style.width.%]="seatFill(webinar)"></div>
          </div>
          <p class="draw-meter__label">
            <ng-container *ngIf="isSoldOut(webinar); else seatsOpen">All seats taken</ng-container>
            <ng-template #seatsOpen>{{ webinar.seatsLeft }} of {{ webinar.numberOfSeats }} seats open</ng-template>
          </p>

          <span class="draw-tile__cta">{{ isSoldOut(webinar) ? 'View draw' : 'Grab a seat' }}</span>
        </div>
      </article>
    </div>
  </section>

</div>
